import { render, staticRenderFns } from "./BaseDeleteIcon.vue?vue&type=template&id=70787664"
import script from "./BaseDeleteIcon.vue?vue&type=script&lang=js"
export * from "./BaseDeleteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports